var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermostat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.89,13.89H2.11V2.11h11.78V13.89z M2.61,13.39h10.78V2.61H2.61V13.39z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.27,5.11v1.48h1.34V7.3H7.27v2.78c0,0.64,0.18,1,0.7,1c0.25,0,0.43-0.03,0.54-0.06l0.04,0.7 c-0.18,0.07-0.47,0.13-0.83,0.13c-0.44,0-0.79-0.14-1.01-0.39c-0.27-0.28-0.36-0.73-0.36-1.34V7.3h-0.8V6.59h0.8V5.36L7.27,5.11z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.02,5.75c-0.48,0-0.87-0.39-0.87-0.87c0-0.48,0.39-0.87,0.87-0.87c0.48,0,0.87,0.39,0.87,0.87 C10.89,5.36,10.5,5.75,10.02,5.75z M10.02,4.51c-0.2,0-0.37,0.17-0.37,0.37s0.17,0.37,0.37,0.37s0.37-0.17,0.37-0.37 S10.23,4.51,10.02,4.51z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermostat);
export default __webpack_public_path__ + "static/media/Thermostat.cf774f443e7e7a0da9ef4803086002bd.svg";
export { ForwardRef as ReactComponent };